/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Project, Project$inboundSchema } from "./project.js";

export type GetProjectResult = {
  project: Project;
};

/** @internal */
export const GetProjectResult$inboundSchema: z.ZodMiniType<
  GetProjectResult,
  unknown
> = z.object({
  project: Project$inboundSchema,
});

export function getProjectResultFromJSON(
  jsonString: string,
): SafeParseResult<GetProjectResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetProjectResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetProjectResult' from JSON`,
  );
}
